import axios, { AxiosRequestConfig } from "axios";
import TokenService from "./token.service";
import { ACT_AS_HEADER, getActingAs } from "../helpers/actingAs";
 
const API_URL = process.env.REACT_APP_API_URL;

// Admin-page calls that live on the act-as controllers instead of under /admin.  Sent as the
// dentist they would fail for any request that isn't that dentist's, so they always run as the admin.
// Edit Status on the Credential Requests page: POST /Credential/{id}/Status
const adminRoutesOutsideAdmin = [/^\/?credential\/\d+\/status$/i];
const isAdminRouteOutsideAdmin = (url?: string) => adminRoutesOutsideAdmin.some((route) => route.test(url ?? ""));

const instance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  }, 
  withCredentials: true 
});

instance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    config.headers = config.headers ?? {}; 
    if (!config.headers['Authorization'] && config.url!=="/user/login" && !config.url?.startsWith("/user/register")&& !config.url?.startsWith("/user/resend-verification-email")) {
        config.headers['Authorization'] = `Bearer ${TokenService.getLocalAccessToken()}`;
    }
    // Admin endpoints always run as the admin, even while acting as a dentist
    const actingAs = getActingAs();
    if (actingAs && !config.url?.toLowerCase().startsWith("/admin") && !isAdminRouteOutsideAdmin(config.url)) {
        config.headers[ACT_AS_HEADER] = actingAs;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;
    if (originalConfig.url == "/user/login" && (err.response.status === 401 || err.response.status === 500)) {
      return JSON.parse('{"data": "'+err.response.data.error+'" }');
    }
    else if (originalConfig.url !== "/user/register" && err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true; 
        try { 
          const rs = await instance.get("/User/refresh-token/"+ TokenService.getLocalRefreshToken(),{ withCredentials: true });
          const { accessToken } = rs.data;
          TokenService.updateLocalAccessToken(accessToken);
          originalConfig.headers['Authorization'] = `Bearer ${accessToken}`;
          return instance(originalConfig);
        } catch (_error: any) {
          if (_error.response.status === 500 || _error.response.status === 400) {
            window.location.href ='/login';
          }
          return Promise.reject(_error);
        }
      }
    }

    return Promise.reject(err);
  }
);

export default instance;